<template>
  <div id="app">
    <p>{{ code }}</p>
    <Transition :name="transitionName">
      <keep-alive include="Layout">
        <router-view class="child-view" />
      </keep-alive>
    </Transition>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { getInviteCode } from "@/utils/inviteCode";

export default {
  created() {
    this.getServiceId();
    this.fetchData();
  },
  methods: {
    ...mapActions("platform", ["getServiceId"]),
    async fetchData() {
      this.code = await getInviteCode();
    }
  },
  data() {
    return {
      transitionName: "slide-left",
      code: ""
    };
  }
};
</script>

<style lang="scss">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.child-view {
  position: absolute;
  min-height: 100%;
  width: 100%;
  transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
}
.slide-left-enter,
.slide-right-leave-active {
  opacity: 0;
  -webkit-transform: translate(30px, 0);
  transform: translate(30px, 0);
}
.slide-left-leave-active,
.slide-right-enter {
  opacity: 0;
  -webkit-transform: translate(-30px, 0);
  transform: translate(-30px, 0);
}
</style>
